import * as yup from 'yup'

import { requiredString, state, string } from '../../yup/schemas.js'
import { VALIDATION } from '../../constants.js'

const { MESSAGES, REGEXP } = VALIDATION

export const billingAddressSchema = yup.object({
  address: yup.object({
    city: requiredString,
    line1: requiredString,
    line2: string,
    postal_code: requiredString.zip(),
    state: state.required(),
    country: requiredString
  }).objectRequired(),
  email: requiredString.email(),
  name: requiredString,
  phone: requiredString.matches(REGEXP.PHONE, MESSAGES.PHONE)
}).objectRequired()

export default {
  createBillingAddress: billingAddressSchema
}
